// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a:hover{
    color: gray;
}
.navbar-nav li {
    margin-left: 40px;
}
.nav2 li {
    margin-right: 10px;
}

.navbar-brand{
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    color: black;
    margin: 0 15px;
    font-size: 44px;
}
.navbar-nav li a {
    color: black;
    margin: 15px;
    font-size: 18px
}
nav.navbar{
    margin-left: 10%;
    margin-right: 10%;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhlYWRlci5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksV0FBVztBQUNmO0FBQ0E7SUFDSSxpQkFBaUI7QUFDckI7QUFDQTtJQUNJLGtCQUFrQjtBQUN0Qjs7QUFFQTtJQUNJLHFDQUFxQztJQUNyQyxnQkFBZ0I7SUFDaEIsWUFBWTtJQUNaLGNBQWM7SUFDZCxlQUFlO0FBQ25CO0FBQ0E7SUFDSSxZQUFZO0lBQ1osWUFBWTtJQUNaO0FBQ0o7QUFDQTtJQUNJLGdCQUFnQjtJQUNoQixpQkFBaUI7QUFDckIiLCJmaWxlIjoiaGVhZGVyLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJhOmhvdmVye1xuICAgIGNvbG9yOiBncmF5O1xufVxuLm5hdmJhci1uYXYgbGkge1xuICAgIG1hcmdpbi1sZWZ0OiA0MHB4O1xufVxuLm5hdjIgbGkge1xuICAgIG1hcmdpbi1yaWdodDogMTBweDtcbn1cblxuLm5hdmJhci1icmFuZHtcbiAgICBmb250LWZhbWlseTogJ01vbnRzZXJyYXQnLCBzYW5zLXNlcmlmO1xuICAgIGZvbnQtd2VpZ2h0OiA1MDA7XG4gICAgY29sb3I6IGJsYWNrO1xuICAgIG1hcmdpbjogMCAxNXB4O1xuICAgIGZvbnQtc2l6ZTogNDRweDtcbn1cbi5uYXZiYXItbmF2IGxpIGEge1xuICAgIGNvbG9yOiBibGFjaztcbiAgICBtYXJnaW46IDE1cHg7XG4gICAgZm9udC1zaXplOiAxOHB4XG59XG5uYXYubmF2YmFye1xuICAgIG1hcmdpbi1sZWZ0OiAxMCU7XG4gICAgbWFyZ2luLXJpZ2h0OiAxMCU7XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/header/header.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;AACA;IACI,YAAY;IACZ,YAAY;IACZ;AACJ;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA,4gCAA4gC","sourcesContent":["a:hover{\n    color: gray;\n}\n.navbar-nav li {\n    margin-left: 40px;\n}\n.nav2 li {\n    margin-right: 10px;\n}\n\n.navbar-brand{\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 500;\n    color: black;\n    margin: 0 15px;\n    font-size: 44px;\n}\n.navbar-nav li a {\n    color: black;\n    margin: 15px;\n    font-size: 18px\n}\nnav.navbar{\n    margin-left: 10%;\n    margin-right: 10%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
